import React, { useState } from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Container,
  Stack
} from '@mui/material';
import UserProfile from './UserProfile';
import SurveyExecutionForm from './SurveyExecutionForm';
import ExecutionStatus from './ExecutionStatus';
import ExecutionHistory from './ExecutionHistory';

export const MainLayout: React.FC = () => {
  const [selectedExecutionId, setSelectedExecutionId] = useState<string | null>(null);
  const [executionHistory, setExecutionHistory] = useState<string[]>([]);

  const handleExecutionStarted = (executionId: string) => {
    setExecutionHistory(prev => [executionId, ...prev]);
    setSelectedExecutionId(executionId);
  };

  const handleSelectExecution = (executionId: string) => {
    setSelectedExecutionId(executionId);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" elevation={1}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 600 }}>
            Survey Taker Platform
          </Typography>
          <UserProfile />
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
        <Stack spacing={3}>
          <SurveyExecutionForm onExecutionStarted={handleExecutionStarted} />
          
          {selectedExecutionId && executionHistory.length > 0 && (
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' }, gap: 3 }}>
              <ExecutionStatus executionId={selectedExecutionId} />
              <ExecutionHistory
                executions={executionHistory}
                onSelectExecution={handleSelectExecution}
                selectedExecutionId={selectedExecutionId || undefined}
              />
            </Box>
          )}
          
          {selectedExecutionId && executionHistory.length === 0 && (
            <ExecutionStatus executionId={selectedExecutionId} />
          )}
          
          {!selectedExecutionId && executionHistory.length > 0 && (
            <ExecutionHistory
              executions={executionHistory}
              onSelectExecution={handleSelectExecution}
              selectedExecutionId={selectedExecutionId || undefined}
            />
          )}
        </Stack>
      </Container>

      <Box
        component="footer"
        sx={{
          py: 2,
          px: 2,
          mt: 'auto',
          backgroundColor: (theme) => theme.palette.grey[100]
        }}
      >
        <Container maxWidth="xl">
          <Typography variant="body2" color="text.secondary" align="center">
            Survey Taker Platform © {new Date().getFullYear()} Bellomy Research
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default MainLayout;

